import React, { Component } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Navbar, NavbarToggler, NavbarBrand, Collapse, Nav, NavItem, NavLink } from 'reactstrap';
import LogOutLink from '../logout_link.js'

class PremiumHeader extends Component {
  state = { isOpen: false }

  render() {
    return (
      <Navbar color="dark" dark expand="md">
        <NavbarBrand href="/">Wreckfinder</NavbarBrand>
        <NavbarToggler onClick={() => {this.setState({isOpen: !this.state.isOpen})}} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink tag={RouterNavLink} to="/wrecks">Wrecks</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={RouterNavLink} to="/account">Account</NavLink>
            </NavItem>
            <NavItem>
               <a class="nav-link" href="//support.wreckfinder.co.uk">Support</a>
            </NavItem>
            <NavItem>
              <LogOutLink className="nav-link">Logout</LogOutLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    )
  }
}

export default PremiumHeader;



// WEBPACK FOOTER //
// ./src/components/headers/premium.js